// module.exports = require('./index.vue')
import scrollBar from './index.vue'

export default scrollBar;


// WEBPACK FOOTER //
// ./index.js